import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const AuthRouteWrapper = () => {
  const isAuthenticated = Boolean(localStorage.getItem("userData"));

  if (!isAuthenticated) {
    // Not logged in → allow public route
    return <Outlet />;
  }

  // Logged in → redirect to fixed page
  return <Navigate to="/admin/dashboard" replace />;
};

export default AuthRouteWrapper;
